module.exports = __webpack_public_path__ + "static/media/StonyIsland.adb3c1b5.ttf";